export default __webpack_public_path__ + "static/media/sals_pizza.10084edb.png";